/** Translation keys used in @mews/business-components */
export const enum BusinessComponentsTextKey {
    AgeCategoryLowerAndUpperBounded = 'AgeCategoryLowerAndUpperBounded',
    AgeCategoryLowerBounded = 'AgeCategoryLowerBounded',
    AgeCategoryUpperBounded = 'AgeCategoryUpperBounded',
    Availability = 'Availability',
    Cancel = 'Cancel',
    Confirm = 'Confirm',
    CountryCode = 'CountryCode',
    Date = 'Date',
    FirstName = 'FirstName',
    GeneralEndDate = 'GeneralEndDate',
    GeneralEndTime = 'GeneralEndTime',
    GeneralStartDate = 'GeneralStartDate',
    GeneralStartTime = 'GeneralStartTime',
    GenericErrorMessage = 'GenericErrorMessage',
    GenericTryAgainErrorMessageWithEmail = 'GenericTryAgainErrorMessageWithEmail',
    GoogleRecaptchaBranding = 'GoogleRecaptchaBranding',
    HourCount = 'HourCount',
    LastName = 'LastName',
    MessageSendFailed = 'MessageSendFailed',
    MessageSending = 'MessageSending',
    MessageSent = 'MessageSent',
    MewsMerchant = 'MewsMerchant',
    MewsPrivacyNotice = 'MewsPrivacyNotice',
    PerPersonPerTimeUnit = 'PerPersonPerTimeUnit',
    PhoneNumber = 'PhoneNumber',
    PlaceholderIsAvailable = 'PlaceholderIsAvailable',
    PlaceholderIsUnavailable = 'PlaceholderIsUnavailable',
    PrivacyPolicy = 'PrivacyPolicy',
    ProductChargingOnce = 'ProductChargingOnce',
    ProductChargingPerPerson = 'ProductChargingPerPerson',
    ProductPostingModeOnce = 'ProductPostingModeOnce',
    PromotionCode = 'PromotionCode',
    Quantity = 'Quantity',
    Remove = 'Remove',
    ResDiaryAllAreas = 'ResDiaryAllAreas',
    ResDiaryArea = 'ResDiaryArea',
    ResDiaryBookingCreated = 'ResDiaryBookingCreated',
    ResDiaryBookingDetails = 'ResDiaryBookingDetails',
    ResDiaryBookingForCustomerText = 'ResDiaryBookingForCustomerText',
    ResDiaryBookingNotes = 'ResDiaryBookingNotes',
    ResDiaryBookingNotesHelperText = 'ResDiaryBookingNotesHelperText',
    ResDiaryCancelBooking = 'ResDiaryCancelBooking',
    ResDiaryCancelTableBooking = 'ResDiaryCancelTableBooking',
    ResDiaryCancellationReason = 'ResDiaryCancellationReason',
    ResDiaryCheckInCheckOutHelperHeader = 'ResDiaryCheckInCheckOutHelperHeader',
    ResDiaryCheckInCheckOutHelperText = 'ResDiaryCheckInCheckOutHelperText',
    ResDiaryConfirmLeaveTime = 'ResDiaryConfirmLeaveTime',
    ResDiaryCopyBookingSummary = 'ResDiaryCopyBookingSummary',
    ResDiaryCreateBookingSuccessfulMessage = 'ResDiaryCreateBookingSuccessfulMessage',
    ResDiaryCreateNewBookingForDate = 'ResDiaryCreateNewBookingForDate',
    ResDiaryCreateTableBookingFailed = 'ResDiaryCreateTableBookingFailed',
    ResDiaryCustomerBlockedMessage = 'ResDiaryCustomerBlockedMessage',
    ResDiaryLockableFieldHelperMessage = 'ResDiaryLockableFieldHelperMessage',
    ResDiaryNoAvailabilityMessage = 'ResDiaryNoAvailabilityMessage',
    ResDiaryNoPromotionsHelperText = 'ResDiaryNoPromotionsHelperText',
    ResDiaryNumberOfPeople = 'ResDiaryNumberOfPeople',
    ResDiaryPhoneNumber = 'ResDiaryPhoneNumber',
    ResDiaryPreferredTime = 'ResDiaryPreferredTime',
    ResDiaryPreferredTimeHelperText = 'ResDiaryPreferredTimeHelperText',
    ResDiaryPromotion = 'ResDiaryPromotion',
    ResDiaryRestaurantAndPeopleNumberText = 'ResDiaryRestaurantAndPeopleNumberText',
    ResDiaryReview = 'ResDiaryReview',
    ResDiaryRoomNumber = 'ResDiaryRoomNumber',
    ResDiarySelectReason = 'ResDiarySelectReason',
    ResDiaryShortPeopleCount = 'ResDiaryShortPeopleCount',
    ResDiarySingleBookingSummaryText = 'ResDiarySingleBookingSummaryText',
    ResDiarySomeAvailabilityBannerHeader = 'ResDiarySomeAvailabilityBannerHeader',
    ResDiarySomeAvailabilityBannerText = 'ResDiarySomeAvailabilityBannerText',
    ResDiarySpecialRequestPlural = 'ResDiarySpecialRequestPlural',
    ResDiaryStay = 'ResDiaryStay',
    ResDiaryStayHelperText = 'ResDiaryStayHelperText',
    ResDiaryStepOfStepsCount = 'ResDiaryStepOfStepsCount',
    ResDiaryTimeForDateNoLongerAvailable = 'ResDiaryTimeForDateNoLongerAvailable',
    ResDiaryTimeSelection = 'ResDiaryTimeSelection',
    ResDiaryToEditNameGoToCustomerProfile = 'ResDiaryToEditNameGoToCustomerProfile',
    ResDiaryUpdateBookingSuccessfulMessage = 'ResDiaryUpdateBookingSuccessfulMessage',
    ResDiaryUpdateTableBooking = 'ResDiaryUpdateTableBooking',
    ResDiaryUpdateTableBookingFailed = 'ResDiaryUpdateTableBookingFailed',
    ResDiaryVenue = 'ResDiaryVenue',
    ResDiaryVisitDate = 'ResDiaryVisitDate',
    ResDiaryVisitTime = 'ResDiaryVisitTime',
    Save = 'Save',
    SecuredWith = 'SecuredWith',
    SelectCurrency = 'SelectCurrency',
    SelectDate = 'SelectDate',
    SelectLanguage = 'SelectLanguage',
    SelectTime = 'SelectTime',
    SuggestedDates = 'SuggestedDates',
    SuggestedTimes = 'SuggestedTimes',
    TermsOfService = 'TermsOfService',
    TryAgain = 'TryAgain',
    TryDifferentTimeOrDate = 'TryDifferentTimeOrDate',
    UnexpectedError = 'UnexpectedError',
    ValidateNumber = 'ValidateNumber',
    ValidateRequired = 'ValidateRequired',
}
